(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvAfter', function($animate, $compile) {
    return {
      restrict: 'A',
      terminal: true,
      priority: 1000,
      compile: function compile(element, attrs) {
        // we store the content and remove it before compilation
        var content = element[0].innerHTML;
        element.html('');

        return function ($scope, $element, $attr) {
          var dereg = $scope.$watch(function() {
            return $scope.$eval($attr.vvAfter);
          }, function(promise) {
            if (promise) {
              dereg();
              promise.then(function () {
                // Attach element contents to DOM and then compile them.
                // This prevents an issue where IE invalidates saved element objects (HTMLCollections)
                // of the compiled contents when attaching to the parent DOM.
                $animate.enter(content, $element);
                // get the new content & compile it
                $compile($element.contents())($scope);
              });
            }
          });
        };
      }
    };
  });
})(window, window.angular);
